import "./CategoriaGuardada.css"

const CategoriaGuardada = () => {
    return (
        <div className="categoriaGuardada">
            <img className="logoError" src="/img/icon-naruto.svg" alt="logo"/>
           <div>
                <h2 className="textoCategoriaGuardada">Categoria Actualizada con éxito!!</h2>
           </div>
        </div>
    )
}

export { CategoriaGuardada }